let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("55BcE")).then(() => parcelRequire('6xXDZ'));